import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TestimonialsSection = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    setCurrentLanguage(savedLanguage);
  }, []);

  const testimonials = [
    {
      id: 1,
      name: 'Sarah Wanjiku',
      title: currentLanguage === 'en' ? 'Business Owner' : 'Mmiliki wa Biashara',
      company: 'Wanjiku Enterprises Ltd',
      image: 'https://images.unsplash.com/photo-14947901b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      rating: 5,
      testimonial: currentLanguage === 'en'
        ? `Peter & Partners helped us navigate a complex corporate restructuring. Their expertise and attention to detail were exceptional. They made what seemed impossible, possible. I highly recommend their services to any business owner.`
        : `Peter & Partners walitusaidia kupitia muundo mgumu wa makampuni. Utaalamu wao na uangalifu wa maelezo ulikuwa wa kipekee. Walifanya kile kilichoonekana haiwezekani, kiwezekane. Ninapendekeza sana huduma zao kwa mmiliki yeyote wa biashara.`,
      caseType: currentLanguage === 'en' ? 'Corporate Restructuring' : 'Muundo wa Makampuni'
    },
    {
      id: 2,
      name: 'James Kiprotich',
      title: currentLanguage === 'en' ? 'Property Developer' : 'Msanidi wa Mali',
      company: 'Kiprotich Properties',
      image: 'https://images.unsplash.com/photo-14720996785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      rating: 5,
      testimonial: currentLanguage === 'en' ? `The team at Peter & Partners resolved our land dispute efficiently and professionally. Judy's expertise in property law was evident throughout the process. We couldn't have asked for better representation.`
        : `Timu ya Peter & Partners ilisuluhisha mgogoro wetu wa ardhi kwa ufanisi na kitaalamu. Utaalamu wa Judy katika sheria ya mali ulikuwa dhahiri katika mchakato wote. Hatukuweza kuomba uwakilishi bora zaidi.`,
      caseType: currentLanguage === 'en' ? 'Land Dispute Resolution' : 'Utatuzi wa Mgogoro wa Ardhi'
    },
    {
      id: 3,
      name: 'Grace Muthoni',
      title: currentLanguage === 'en' ? 'Single Mother' : 'Mama Mjane',
      company: currentLanguage === 'en' ? 'Private Individual' : 'Mtu Binafsi',
      image: 'https://images.unsplash.com/photo-14387616810361ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      rating: 5,
      testimonial: currentLanguage === 'en'
        ? `During my divorce proceedings, Peter & Partners provided compassionate and professional support. They fought for my rights and ensured my children's best interests were protected. I'm grateful for their dedication.`
        : `Wakati wa michakato yangu ya talaka, Peter & Partners walitoa msaada wa huruma na kitaalamu. Walipigania haki zangu na kuhakikisha maslahi bora ya watoto wangu yanalindwa. Ninashukuru kwa kujitolea kwao.`,
      caseType: currentLanguage === 'en' ? 'Family Law & Custody' : 'Sheria ya Familia na Ulinzi'
    },
    {
      id: 4,
      name: 'Michael Ochieng',
      title: currentLanguage === 'en' ? 'CEO' : 'Mkurugenzi Mkuu',
      company: 'TechStart Kenya',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1df2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      rating: 5,
      testimonial: currentLanguage === 'en'
        ? `As a startup, we needed legal guidance that understood our unique challenges. Peter & Partners provided strategic advice that helped us secure funding and establish proper corporate governance. Excellent service!`
        : `Kama kampuni mpya, tulihitaji mwongozo wa kisheria ambao unaelewa changamoto zetu za kipekee. Peter & Partners walitoa ushauri wa kimkakati ambao ulitusaidia kupata fedha na kuanzisha utawala bora wa makampuni. Huduma bora!`,
      caseType: currentLanguage === 'en' ? 'Startup Legal Advisory' : 'Ushauri wa Kisheria wa Kampuni Mpya'
    }
  ];

  const content = {
    en: {
      sectionTitle: "What Our Clients Say",
      sectionSubtitle: "Real Stories from Real Clients",
      nextButton: "Next",
      prevButton: "Previous"
    },
    sw: {
      sectionTitle: "Wateja Wetu Wanasema Nini",
      sectionSubtitle: "Hadithi za Kweli kutoka kwa Wateja wa Kweli",
      nextButton: "Ifuatayo",
      prevButton: "Iliyotangulia"
    }
  };

  const currentContent = content[currentLanguage];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const currentTestimonialData = testimonials[currentTestimonial];

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-primary/5 to-accent/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center mb-6">
            <div className="flex items-center space-x-2 bg-warning/10 px-4 py-2 rounded-full">
              <Icon name="MessageSquare" size={20} className="text-warning" />
              <span className="text-sm font-medium text-warning">
                {currentLanguage === 'en' ? 'Client Testimonials' : 'Ushuhuda wa Wateja'}
              </span>
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-text-primary mb-6">
            {currentContent.sectionTitle}
          </h2>
          
          <p className="text-lg md:text-xl text-text-secondary max-w-3xl mx-auto leading-relaxed">
            {currentContent.sectionSubtitle}
          </p>
        </div>

        {/* Testimonial Display */}
        <div className="max-w-4xl mx-auto">
          <div className="card-elevated p-8 lg:p-12 relative">
            {/* Navigation Buttons */}
            <div className="absolute top-1/2 -translate-y-1/2 left-4 lg:-left-16">
              <button
                onClick={prevTestimonial}
                className="w-12 h-12 bg-white shadow-lg rounded-full flex items-center justify-center hover:bg-primary hover:text-white transition-all duration-300 focus-ring"
                aria-label={currentContent.prevButton}
              >
                <Icon name="ChevronLeft" size={20} />
              </button>
            </div>

            <div className="absolute top-1/2 -translate-y-1/2 right-4 lg:-right-16">
              <button
                onClick={nextTestimonial}
                className="w-12 h-12 bg-white shadow-lg rounded-full flex items-center justify-center hover:bg-primary hover:text-white transition-all duration-300 focus-ring"
                aria-label={currentContent.nextButton}
              >
                <Icon name="ChevronRight" size={20} />
              </button>
            </div>

            {/* Quote Icon */}
            <div className="flex justify-center mb-8">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
                <Icon name="Quote" size={32} className="text-primary" />
              </div>
            </div>

            {/* Testimonial Content */}
            <div className="text-center mb-8">
              <blockquote className="text-lg md:text-xl text-text-primary leading-relaxed mb-6 italic">
                "{currentTestimonialData.testimonial}"
              </blockquote>

              {/* Rating */}
              <div className="flex items-center justify-center space-x-1 mb-6">
                {[...Array(currentTestimonialData.rating)].map((_, index) => (
                  <Icon key={index} name="Star" size={20} className="text-warning fill-current" />
                ))}
              </div>

              {/* Case Type Badge */}
              <div className="inline-flex items-center space-x-2 bg-accent/10 px-4 py-2 rounded-full mb-6">
                <Icon name="Briefcase" size={16} className="text-accent" />
                <span className="text-sm font-medium text-accent">
                  {currentTestimonialData.caseType}
                </span>
              </div>
            </div>

            {/* Client Info */}
            <div className="flex items-center justify-center space-x-4">
              <div className="w-16 h-16 rounded-full overflow-hidden ring-4 ring-primary/20">
                <Image
                  src={currentTestimonialData.image}
                  alt={`${currentTestimonialData.name} testimonial`}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="text-left">
                <h4 className="font-heading font-semibold text-text-primary">
                  {currentTestimonialData.name}
                </h4>
                <p className="text-text-secondary text-sm">
                  {currentTestimonialData.title}
                </p>
                <p className="text-primary text-sm font-medium">
                  {currentTestimonialData.company}
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial Indicators */}
          <div className="flex items-center justify-center space-x-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentTestimonial(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentTestimonial
                    ? 'bg-primary w-8' :'bg-border hover:bg-primary/50'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;